import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireStaffAdmin } from '../auth/guard.ts'
import { staffRoute } from './staff.tsx'

// Inviting a colleague, a Panel over the list; admin-only, since a non-admin cannot finish the POST.
// Why a child route: apps/admin-panel/docs/pattern-di-una-feature.md § «Si crea in un Pannello sopra la lista»
export const newStaffRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: 'new',
  beforeLoad: requireStaffAdmin,
  component: lazyRouteComponent(() => import('../pages/new-staff.tsx')),
})
